'use client';
import TablistBtns from '@/components/TablistBtns';
import { usePathname, useRouter } from 'next/navigation';
import { User, ShoppingBag, Heart, Tally4 } from 'lucide-react';

const NAV_OPTIONS = [
  { title: 'Account', value: '/account', icon: User },
  { title: 'Orders', value: '/orders', icon: ShoppingBag },
  { title: 'Wishlist', value: '/wishlist', icon: Heart },
  { title: 'Points', value: '/points', icon: Tally4 },
];

const PAGE_TITLES = {
  '/account': 'Account',
  '/orders': 'Orders',
  '/wishlist': 'Wishlist',
  '/points': 'Points',
};

const AccountMenu = () => {
  const pathname = usePathname();
  const router = useRouter();

  return (
    <div className="text-center mb-8">
      <h1 className="text-3xl font-bold text-brand-navy mb-6">
        {PAGE_TITLES[pathname] || 'My Account'}
      </h1>
      <div className="flex justify-center">
        <TablistBtns
          options={NAV_OPTIONS}
          value={pathname}
          labelSuffix=""
          onChange={(value) => router.push(value)}
          containerClass="w-auto"
        />
      </div>
    </div>
  );
};

export default AccountMenu;